module.exports = __webpack_public_path__ + "img/max_logo.bef6e220.png";